<template>
    <div class="aup-base-messagebox mb-4"
        :class="{
            'aup-base-messagebox--primary': backgroundColor === 'primary',
            'aup-base-messagebox--hidden': isHidden,
            }">
		<h3 class="mb-4" :style="{color: textColor}"><slot name="headerTitle">error:call:12</slot></h3>
        <BaseButton
            class="aup-base-messagebox__close"
            :filled="false"
            border="round"
            color="white"
            @click="hideMessage"
        >
            <IconClose />
        </BaseButton>
        <slot/>
        <a class="aup-base-button solid-white py-1 px-3 t-micro text-uppercase mt-2 d-inline-block" v-if="link && linkTitle" :href="`${profileUrl}${link}/`">error:call:13</a>

    </div>
</template>
<script>
    import { PROFILE_CONSTANTS } from "@/PROFILE_CONSTANTS";
	export default {
		name: "BaseMessageBox",
		props: {
			title: {
				type: String,
				default: "User Message"
            },
            backgroundColor: {
                type: String,
                default: "white"
            },
            textColor: {
                type: String,
                default: "inherit"
            },
            link: {
                type: String,
                default: ''
            },
            linkTitle: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                isHidden: false,
                profileUrl: PROFILE_CONSTANTS.PROFILE_URL,
            }
        },
        methods: {
            hideMessage() {
                this.isHidden = true;
                this.$store.commit('updateProfileNewStatus', false);
            }
        }
    };
</script>

<style lang="scss">
    @import "../../assets/scss/all";
    .aup-base-messagebox {
        background-color: $white;
        color: $black;
        padding: 2rem;
        box-shadow: 6px 6px 10px 4px rgba(19, 19, 19, 0.096);

        &__close {
            position: absolute;
            top: 2rem;
            right: 2rem;
        }

        &--primary {
            background-color: $primary;
            color: $white;
        }

        &--hidden {
            transform: translateX(-100vw);
            transform-origin: right;
            transition: transform .4s ease-in-out;
        }
    }
</style>
